/**
 * The current time, re-rendering every minute — so "5m ago" labels keep
 * up. One shared interval for every subscriber (a chat renders many), which
 * only runs while something is listening.
 *
 *   const now = useNow();
 */

import { useSyncExternalStore } from 'react';

const TICK_MS = 60 * 1000;
let now = Date.now();
let timer = null;
const listeners = new Set();

function subscribe(listener) {
    listeners.add(listener);
    if (!timer) {
        now = Date.now();
        timer = setInterval(() => { now = Date.now(); listeners.forEach(l => l()); }, TICK_MS);
    }
    return () => {
        listeners.delete(listener);
        if (!listeners.size) { clearInterval(timer); timer = null; }
    };
}

export function useNow() {
    return useSyncExternalStore(subscribe, () => now);
}
